// Helpers for inline links/forms that trigger Turbo navigation.
// Exposed on window so HAML onclick attributes can reach them.

// Disables a clicked inline action link and swaps it for a spinner after Turbo sees the click.
window.disable_link = function disable_link(element) {
  if (!element || element.dataset.phqDisabling === "true") return;
  element.dataset.phqDisabling = "true";
  element.style.pointerEvents = "none";

  // Let Turbo's delegated click handler see the original link before replacing it.
  setTimeout(() => {
    $(element).replaceWith('<i class="fa-fw fas fa-spinner fa-spin"></i>');
  }, 0);
};
